import {StyleSheet, View, Text, TouchableOpacity, Image} from "react-native";
import {
    BORDER_COLOR,
    CONNECTED_COLOR,
    DATA_COLOR,
    NOT_CONNECTED_COLOR,
    PRIMARY_BACKGROUND_COLOR
} from "../../Config/Colors";
import {DATA_FONT_SIZE, DATA_GRID_BORDER_WIDTH, DATA_GRID_HEIGHT} from "../../Config/Constants";
import React from "react";
import EditIcon from '../../Images/Icons/edit.png';
import PowerProxy from "../../Domain/Models/PowerProxy";

/**
 * Data Grid Item Props.
 */
interface PowerProxyDataGridItemProps
{
    /**
     * The index.
     */
    index: number;
    
    /**
     * The power proxy.
     */
    powerProxy: PowerProxy;

    /**
     * Callback when the edit button was selected.
     * @param powerProxy The power proxy.
     */
    onEditButtonSelected?: (powerProxy: PowerProxy) => void;
}

/**
 * Renders the Power Proxy Data Grid Item.
 * @param index The index.
 * @param powerProxy The power proxy.
 * @param onEditButtonSelected Callback when the edit button was selected.
 * @constructor
 */
export default function PowerProxyDataGridItem({
    index = 0,
    powerProxy,
    onEditButtonSelected,
}: PowerProxyDataGridItemProps)
{
    const getConnectionStatus = (): string =>
    {
        return powerProxy.isConnected ? "Connected" : "Not Connected";
    }
    
    const onEditPressed = (): void =>
    {
        if (onEditButtonSelected !== undefined)
        {
            onEditButtonSelected(powerProxy);
        }
    }

    const getConnectionColor = (): string =>
    {
        return powerProxy.isConnected ? CONNECTED_COLOR: NOT_CONNECTED_COLOR;
    }
    
    return (
        <View style={styles.container}>
            <View style={[styles.item, {
                flex: 0.17,
            }]}>
                <Text
                    numberOfLines={2}
                    style={[styles.text, {
                        textAlign: 'center',
                    }]}
                >
                    {index + 1}
                </Text>
            </View>
            
            <View style={styles.item}>
                <Text
                    numberOfLines={2}
                    style={[styles.text, {
                        color: getConnectionColor(),
                    }
                ]}>
                    {powerProxy.name}
                </Text>
            </View>

            <View style={styles.item}>
                <Text
                    numberOfLines={2}
                    style={[styles.text, {
                        color: getConnectionColor(),
                    }
                ]}>
                    {powerProxy.id}
                </Text>
            </View>

            <View style={styles.item}>
                <Text
                    numberOfLines={2}
                    style={[styles.text, {
                        color: getConnectionColor(),
                    }
                ]}>
                    {getConnectionStatus()}
                </Text>
            </View>

            <View style={[styles.item, {
                flex: 0.17,
            }]}>
                <TouchableOpacity
                    style={styles.editButton}
                    onPress={onEditPressed}
                >
                    <Image
                        source={EditIcon}
                        resizeMode={"contain"}
                        style={styles.icon}
                    />
                </TouchableOpacity>
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: PRIMARY_BACKGROUND_COLOR,
        width: "100%",
        height: DATA_GRID_HEIGHT,
        alignItems: 'center',
        flexDirection: 'row',
    },
    checkBox: {
        width: '55%',
        height: undefined,
        aspectRatio: 1,
    },
    editButton: {
        width: '50%',
        height: undefined,
        aspectRatio: 1,
        opacity: 0.7,
    },
    item: {
        flex: 1,
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        borderColor: BORDER_COLOR,
        borderWidth: DATA_GRID_BORDER_WIDTH,
        borderTopColor: 'transparent',
        borderTopWidth: 0,
    },
    text: {
        alignSelf: 'flex-start',
        textAlign: 'left',
        fontSize: DATA_FONT_SIZE,
        color: DATA_COLOR,
        width: '90%',
        paddingLeft: '5%',
        fontWeight: '600',
    },
    icon: {
        width: undefined,
        height: '100%',
        aspectRatio: 1,
    },
});
